<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<div class="signin-popup forget-popup">
  <div class="signin-wrap" id="signin-wrap">
    <a (click)="closecomponent()" class="close-btn"><i class="icon-close"></i></a>
    <div class="popup-logo text-center">
      <a href="#"><img src="https://www.mylifewell.com/assets/images/logo/300.png" alt="logo"></a>
    </div>
    <form class="login-form" [formGroup]="forgetPassword" (submit)="submitpassword()">
      <p class="forget-desc text-center text-md-left">
        Enter your e-mail address associated with your account on My Life Well, and we will send you a link to change
        your password.
      </p>
      <p style="font-style: italic;margin-bottom: 20px;">
        Don't forget to check your spam or social and promotions tabs as well.
      </p>
      <div class="form-group">
        <input class="form-control" formControlName="email" type="text" placeholder="demo123@example.com" />
        <i class="icon-email"></i>
        <div class="invalid-feedback">
          <span *ngIf="submitted && ( f['email'] && f['email']['errors']&& f['email']['errors'].required)">
            Enter the email associated with your account. We'll send you a link to reset your password
          </span>
          <span *ngIf="submitted && ( f['email'] && f['email']['errors']&& f['email']['errors'].emailDomain)">
            We don't recognize this email. Please enter the email associated with your account.
          </span>
          <span *ngIf="submitted && ( f['email'] && f['email']['errors']&& f['email']['errors'].pattern)">We don't
            recognize this email. Please enter the email associated with your account.</span>
          <span *ngIf="submitted && errorMessage">
            {{errorMessage}}
          </span>
        </div>
      </div>

      <div class="buttons-wrap">
        <button type="submit" class="btn">Get the link</button>
      </div>
    </form>
  </div>
</div>
<div class="enquiry-poup">
  <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
  </app-modal-pop-up>
</div>